import { createApp } from 'vue'
import axios from 'axios'
import ChurchesSelector from '@components/ChurchesSelector.vue'
import siloLocationSelector from '@components/siloLocationSelector.vue'
import UserPersonSelector from '@components/UserPersonSelector.vue'
import FormResponseSearchableSelect from '@components/FormResponseSearchableSelect.vue'
import GlobalEventBus from '@services/GlobalEventBus'
import TurbolinksAdapter from 'vue-turbolinks'
import EntityLocationSelector from '@components/EntityLocationSelector'

export default () => {

  const formTypeElem = document.querySelector('.form-type')
  if (formTypeElem) {
    let formTypeCode = formTypeElem.id.replace('-form','').replace('-visit','')
    console.log(formTypeElem.id)
    console.log(formTypeCode)
    placeFrSelectComponents(formTypeCode)
    placeSubmitFor(formTypeCode)

    if (formTypeCode == 'pre-launch') {
      let checkBox = document.getElementById('form_responses_pre_launch_training_center_visit_form_does_recommend')
      let hiddenElem = document.getElementById('hidden-reason')
      toggleTCvisitElems(checkBox, hiddenElem, 'no', '==')
      let otherPrograms = document.getElementById('form_responses_pre_launch_training_center_visit_form_paul_has_other_programs')
      let additionalFeedbackPrograms = document.getElementById('hidden-programs-feedback')
      toggleTCvisitElems(otherPrograms, additionalFeedbackPrograms, 'yes', '==')
    }

    console.log('adding event listeners')
    let tcgElem = document.querySelector('.tcg-select')
    console.log(tcgElem)
    if (tcgElem) {
      let graduated = tcgElem.dataset.graduated
      tcgElem.addEventListener('change', () => {
        fetchTcsForTcg(tcgElem.options[tcgElem.selectedIndex].value, graduated)
          .then(resp => {
            GlobalEventBus.dispatch('clear-fields', true)
            console.log('tcgChange')
            GlobalEventBus.dispatch('training-center-group-change', resp.data)
          })
      })
      if (tcgElem.selectedIndex) {
        console.log('TCG selected')
        console.log(tcgElem.selectedIndex)
        tcgElem.dispatchEvent(new Event('change'))
      }
    }

    // ******************** Entity Location Selector on FormResponses ******************** 
    if (document.getElementById('entity-location-selector')) {
      const elems = document.querySelectorAll('.point-selector-container')
      let data = JSON.parse(elems[0].dataset.pointData)
  
      const props = {
        pointData: data,
        apiKey: window.gon.googleMapsApiKey,
      }
  
      const entityLocationSelectorVueApp = createApp(EntityLocationSelector, props)
      entityLocationSelectorVueApp.config.globalProperties.$rollbar = window.Rollbar
  
      entityLocationSelectorVueApp.config.errorHandler = (err, vm, info) => {
        window.Rollbar.error(err, info)
        throw err
      }
  
      entityLocationSelectorVueApp.use(TurbolinksAdapter)
      entityLocationSelectorVueApp.mount('#entity-location-selector')
    }
    // ******************** End of Entity Location Selector on FormResponses ******************** 


    
    //this doesn't appear to be used anywhere? No elements defined with this ID in any form
    // let choosePersonCheckBox = document.getElementById('choose-person-checkbox')
    // if (choosePersonCheckBox) {
    //   choosePersonCheckBox.addEventListener('change', function () {
    //     if (choosePersonCheckBox.checked) {
    //       let usersPersonSelectElem = document.getElementById('country-select')
    //       if (usersPersonSelectElem) {
    //         let vueInstance = null
    //         let filtered_person_data = null

    //         document.querySelectorAll('.vselect').forEach(el => {
    //           let pData = {
    //             options: JSON.stringify([]),
    //             labelName: 'name',
    //             valueName: 'id',
    //             hiddenElement: 'hidden-person-id',
    //           }

    //           vueInstance = new Vue({
    //             el,
    //             render: createElement => {
    //               const context = {
    //                 props: {
    //                   ...pData,
    //                 },
    //               }
    //               return createElement(UserPersonSelector, context)
    //             },
    //           })
    //         })

    //         let countryElem = document.getElementById("country-select")
    //         countryElem.addEventListener('change', function () {
    //           filtered_person_data = JSON.parse(gon.person_data['person-select'].options)
    //             .filter(person => person.country_id == countryElem.options[countryElem.selectedIndex].value)

    //           if (vueInstance != null) {
    //             vueInstance.$destroy()
    //           }

    //           document.querySelectorAll('.vselect').forEach(el => {
    //             let pData2 = gon.person_data[el.id]

    //             vueInstance = new Vue({
    //               el,
    //               render: createElement => {
    //                 const context = {
    //                   props: {
    //                     ...pData2,
    //                     filtered_person_data: filtered_person_data
    //                   },
    //                 }
    //                 return createElement(UserPersonSelector, context)
    //               },
    //             })
    //           })
    //         })
    //       }
    //     } else {
    //       console.log("unset person stuff from 'choose person'")
    //     }
    //   })
    // }
    //end of unused code block
    //another unused segment
    // if (document.getElementById('add-visit-button')) {
    //   let addVisitButton = document.getElementById('add-visit-button')
    //   let hiddenElem = document.getElementById('add-visit-hidden')
    //   let cancelButton = document.getElementById('cancel-button-home')

    //   addVisitButton.addEventListener('click', () => {
    //     addVisitButton.style.display = 'none'
    //     hiddenElem.style.display = 'grid'
    //   })

    //   cancelButton.addEventListener('click', () => {
    //     addVisitButton.style.display = 'flex'
    //     hiddenElem.style.display = 'none'
    //   })
    // }


    function toggleTCvisitElems(elem, hiddenElem, expected_value, operator) {
      if (elem && hiddenElem) {
        if (operator == "!=") {
          elem.addEventListener('change', () => {
            if (elem.options[elem.selectedIndex].value != expected_value) {
              hiddenElem.style.display = 'grid'
            } else {
              hiddenElem.style.display = 'none'
            }
          })
        } else if (operator == 'or') {
          elem.addEventListener('change', () => {
            if (elem.options[elem.selectedIndex].value == 'level_1' || elem.options[elem.selectedIndex].value == 'level_2') {
              hiddenElem.style.display = 'grid'
            } else {
              hiddenElem.style.display = 'none'
            }
          })
        } else {
          if (elem) {
            elem.addEventListener('change', () => {
              if (elem.options[elem.selectedIndex].value == expected_value) {
                hiddenElem.style.display = 'grid'
              } else {
                hiddenElem.style.display = 'none'
              }
            })
          }
        }
      }
    }

    function fetchTcsForTcg(trainingCenterGroupId, graduated = false) {
      return axios.get('/training_centers.json', {
        params: {
          training_center_group_id: trainingCenterGroupId,
          state: graduated ? 'graduated' : 'available',
          graduated: graduated
        }
      }, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
      })
    }

    function fetchCountriesForPerson(person_id) {
      return axios.get(`/countries.json`, {
        params: {
          person_id: person_id,
          has_person_role_type_in: 'leader'
        }
      }, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
      })
    }

    function setUpLocationSelector(countryName, manager, locationVueElem) {
      console.log (`country selector for ${countryName}`)
      console.log(manager)
      console.log(locationVueElem)
      if (locationVueElem) {
        locationVueElem.$destroy()
      }

      let selectedRegionElem = null
      let countryElem = document.getElementById('pre-launch-country-elem')

      const location = document.getElementById('pre-launch-location-el')
      if (location) {
        location.innerHTML = '<input class="silo-select" id="silo-select" type="text" name="pre_launch_form[proposed_location_overall]">'
      }

      if (countryElem) {
        countryName = manager ? countryName : countryElem.innerText
        countryName = countryName ? countryName.trim() : null
      }

      let countryData = (gon.countries_with_iso3 || []).find(c => c.name == countryName)
      let silo_details = countryData ? countryData.silo_details : null

      if (!countryData) {
        return -1
      }
      // turn off silo location option -- as per Jesse
      if (1==0 && silo_details && location) {
        let levels = Object.assign([], silo_details.levels)

        // remove the final level so location is not too specific
        levels.pop()

        const props = {
          levels: levels,
          countryCode: countryData.iso3_code,
          location: gon.location || {},
        }

        const siloLocationSelectorVueApp = createApp(siloLocationSelector, props)
        siloLocationSelectorVueApp.use(TurbolinksAdapter)
        siloLocationSelectorVueApp.mount('#silo-select')

        let vueHiddenStateElem = document.getElementById("vue-hidden-location-admin1_name")
        let vueHiddenDistrictElem = document.getElementById("vue-hidden-location-admin2_name")
        let vueHiddenBlockElem = document.getElementById("vue-hidden-location-admin3_name")

        let hiddenLocationState = document.getElementById("proposed-location-state-hidden-field")
        let hiddenLocationDistrict = document.getElementById("proposed-location-district-hidden-field")
        let hiddenLocationBlock = document.getElementById("proposed-location-block-hidden-field")
        let hiddenLocationOverall = document.getElementById('proposed-location-overall-hidden-field')
        let buttonPressed = document.getElementById("form-submit-button")

        if (buttonPressed) {
          buttonPressed.addEventListener('click', () => {
            hiddenLocationState.value = vueHiddenStateElem && vueHiddenStateElem.innerText
            hiddenLocationDistrict.value = vueHiddenDistrictElem && vueHiddenDistrictElem.innerText
            hiddenLocationBlock.value = vueHiddenBlockElem && vueHiddenBlockElem.innerText
            hiddenLocationOverall.value = null
          })
        }
      } else {
        let preLaunchLocEl = document.getElementById("pre-launch-location-el")
        if (preLaunchLocEl) {
          setTimeout(() => {
            preLaunchLocEl.children[0].value = gon.location
          }, 300)
        }

        // if not in silo, just type in
        selectedRegionElem = document.getElementById("silo-select")

        let hiddenLocationOverall = document.getElementById('proposed-location-overall-hidden-field')
        let buttonPressed = document.getElementById("form-submit-button")
        let hiddenLocationState = document.getElementById("proposed-location-state-hidden-field")
        let hiddenLocationDistrict = document.getElementById("proposed-location-district-hidden-field")
        let hiddenLocationBlock = document.getElementById("proposed-location-block-hidden-field")

        if (buttonPressed) {
          buttonPressed.addEventListener('click', () => {
            hiddenLocationOverall && (hiddenLocationOverall.value = selectedRegionElem.value)
            hiddenLocationState && (hiddenLocationState.value = '')
            hiddenLocationDistrict && (hiddenLocationDistrict.value = '')
            hiddenLocationBlock && (hiddenLocationBlock.value = '')
          })
        }
      }
    }

    function placeFrSelectComponents(formTypeCode) {
      document.querySelectorAll('.fr-select').forEach(el => {
        let pData = gon.select_data[el.id]
        console.log(el.id)
        console.log(formTypeCode)
        console.log(el.id)
        console.log(pData)
        console.log(gon.select_data)

        const props = {
          ...pData,
          formType: formTypeCode,
        }

        const formResponseSearchableSelectVueApp = createApp(FormResponseSearchableSelect, props)
        formResponseSearchableSelectVueApp.use(TurbolinksAdapter)
        formResponseSearchableSelectVueApp.mount(el)
      })

      // place church selector if present
      document.querySelectorAll('.ch-select').forEach(el => {
        let pData = gon.select_data[el.id]
        console.log(el.id)
        console.log(formTypeCode)
        console.log(el.id)
        console.log(pData)
        console.log(gon.select_data)
        
        const props = {
          ...pData,
          formType: formTypeCode,
          church_id: gon.church_id,
          formResponseEntityLocation: gon.form_response_entity_location,
          church: gon.church
        }

        const churchesSelectorVueApp = createApp(ChurchesSelector, props)
        churchesSelectorVueApp.use(TurbolinksAdapter)
        churchesSelectorVueApp.mount(el)
      })
    }

    function placeSubmitFor(formTypeCode) {
      let submitForElem = document.querySelector(".submit-for")
      if (submitForElem) {
        submitForElem.addEventListener('change', () => {
          GlobalEventBus.dispatch('clear-fields', true)

          fetchCountriesForPerson(submitForElem.options[submitForElem.selectedIndex].value)
            .then(resp => {
              let countryArray = resp.data.data
              GlobalEventBus.dispatch('person-change', countryArray)
            })
        })
        if (formTypeCode == 'pre-launch') {
          // set up default location elem
          setUpLocationSelector(null, null, null)

          GlobalEventBus.subscribe('determine-location', country => {
            let countryName = country == false ? null : country.name
            setUpLocationSelector(countryName, true, null)
          })
        }
      } else if (formTypeCode == 'pre-launch') {
        setUpLocationSelector(gon.found_country.name, false, null)
      }
    }
  }
  // this block is only referenced in a non-form view people/show --  should this be moved to application.js?
  if (document.getElementById('initiate-association-button')) {
    let initiateElem = document.getElementById('initiate-association-button')
    let hiddenElem = document.getElementById('associate-elem-hidden')
    let cancelButton = document.getElementById('cancel-button')

    initiateElem.addEventListener('click', () => {
      console.log('bloop')
      initiateElem.style.display = 'none'
      hiddenElem.style.display = 'flex'
    })

    cancelButton.addEventListener('click', () => {
      console.log('blooper')
      initiateElem.style.display = 'flex'
      hiddenElem.style.display = 'none'
    })
  }
}